/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'team-central.give-jira-kudos.created.description.flag': '我們的 Workplace Experience 團隊現在將努力處理禮物要求。✨',
  'team-central.give-jira-kudos.created.title.flag': '已建立讚美',
  'team-central.give-jira-kudos.creation.failed.description.flag': '我們傳送了讚美，但由於發生錯誤，無法傳送禮物。請在 <a>go/kudos</a> 中提出個別的工單。',
  'team-central.give-jira-kudos.creation.failed.title.flag': '我們無法傳送禮物',
  'team-central.give-kudos.button': '給予讚美',
  'team-central.give-kudos.close-button.label': '關閉抽屜',
  'team-central.give-kudos.confirm-close.title': '確認關閉',
  'team-central.give-kudos.created.description.flag': '您的讚美已傳送。<a>檢視讚美</a>',
  'team-central.give-kudos.created.title.flag': '已建立讚美',
  'team-central.give-kudos.success-icon.label': '成功',
  'team-central.give-kudos.unsaved.warning': '您所做的變更將不會儲存。',
  'team-central.give-kudos.unsaved.warning.cancel': '取消',
  'team-central.give-kudos.unsaved.warning.close': '關閉'
};